import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, Row } from '~/commonComponents';
import { CheckSingleIcon } from '~/images/icons';
import CandidateSearchIcon from '~/images/perm/candidate-search-icon.svg';

export const PermanentJobsTips = () => {
  return (
    <Column
      backgroundColor={colors.secondary[50]}
      borderRadius={8}
      paddingBlock={30}
      paddingInline={35}
    >
      <Typography as="span" bold color={colors.primary[500]} size="body_large">
        Start Receiving Qualified Candidates Today
      </Typography>
      <Column gap={14} marginTop={14} marginBottom={26}>
        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Pre-screened, qualified applicants</Typography> from GoTu’s vetted dental
              network.
            </Typography>
          </Column>
        </Row>

        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Facilitated onsite interviews</Typography> show you how candidates perform before
              you make a hire.
            </Typography>
          </Column>
        </Row>

        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Your job stays live for 30 days with auto-renewal</Typography>, keeping you top
              of mind.
            </Typography>
          </Column>
        </Row>
      </Column>
      <Row
        alignItems="center"
        backgroundColor="#D1EDF2"
        borderRadius={8}
        gap={15}
        paddingBlock={15}
        paddingInline={12}
      >
        <img src={CandidateSearchIcon} alt="candidate-search-icon" />
        <Column>
          <Typography as="span" bold color={colors.primary[500]} size="body_large">
            The GoTu Difference
          </Typography>
          <Typography as="span">
            Less searching, better choices, build a stronger, more reliable team from day one with
            GoTu.
          </Typography>
        </Column>
      </Row>
    </Column>
  );
};
